'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174() {
  this.cf9 = null;
  this.cf7 = null;
  this.cf8 = false;
  this.cf5 = null;
  this.cf6 = false;
  this.cfa = false;
  this.cfb = false;
  this.cf9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 as $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 };
$p = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174;
/** @constructor */
function $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174() {
}
export { $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 as $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 };
$h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.cf9;
});
$p.t = (function() {
  if ((!this.cf8)) {
    this.cf7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cf8 = true;
  }
  return this.cf7;
});
$p.ae = (function() {
  if ((!this.cf6)) {
    this.cf5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cf6 = true;
  }
  return this.cf5;
});
$p.w = (function() {
  if ((!this.cfb)) {
    this.cfa = false;
    this.cfb = true;
  }
  return this.cfa;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174, "presto.types$proto$StoreTwoFactorAuthRequestPayload$$anon$174", ({
  a3A: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 as $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 };
//# sourceMappingURL=presto.types$proto$-Store-Two-Factor-Auth-Request-Payload$$anon$174.js.map
